export const API_URL="https://api.project-visualizer.s2.develops.hu";